/* eslint-disable */
import './index.css'
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// Register Service Worker for PWA installability
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('BPG PWA ServiceWorker registered successfully:', registration.scope);
      })
      .catch((error) => {
        console.error('BPG PWA ServiceWorker registration failed:', error);
      });
  });
}
